var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_567_480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_567_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00929 5.57609C3.44258 5.57609 2.98315 5.11667 2.98315 4.54995V2.82692C2.98315 2.2602 3.44258 1.80078 4.00929 1.80078C4.57601 1.80078 5.03544 2.2602 5.03544 2.82692V4.54995C5.03544 5.11667 4.57601 5.57609 4.00929 5.57609Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5291 5.57609C14.9624 5.57609 14.5029 5.11667 14.5029 4.54995V2.82692C14.5029 2.2602 14.9624 1.80078 15.5291 1.80078C16.0958 1.80078 16.5552 2.2602 16.5552 2.82692V4.54995C16.5552 5.11667 16.0958 5.57609 15.5291 5.57609Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6409 5.57609C19.0742 5.57609 18.6147 5.11667 18.6147 4.54995V2.82692C18.6147 2.2602 19.0742 1.80078 19.6409 1.80078C20.2076 1.80078 20.667 2.2602 20.667 2.82692V4.54995C20.667 5.11667 20.2076 5.57609 19.6409 5.57609Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7885 17.6699V20.4077",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3542 19.0393C21.3542 19.7713 20.948 20.3506 20.3034 20.3619C20.0888 20.3656 19.5343 20.3677 19.5343 20.3677C19.5343 20.3677 19.5309 19.4054 19.5309 19.0364C19.5309 18.7333 19.5289 17.7109 19.5289 17.7109H20.2813C20.9883 17.7109 21.3542 18.3073 21.3542 19.0393Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41016 17.6699L7.33611 20.4077",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20069 17.6699L5.27197 20.4077",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.931 19.1016L15.0811 20.4083",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6008 17.6699V20.4077",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.081 18.3815C15.081 18.7744 14.7364 19.093 14.3292 19.093C14.1272 19.093 13.6068 19.0961 13.6068 19.0961C13.6068 19.0961 13.6035 18.5796 13.6035 18.3815C13.6035 18.2188 13.6017 17.6699 13.6017 17.6699H14.3292C14.7364 17.6699 15.081 17.9885 15.081 18.3815Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79688 17.6699V20.4077",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.347 18.4425C10.347 18.8692 9.98598 19.2151 9.55928 19.2151C9.34768 19.2151 8.80229 19.2186 8.80229 19.2186C8.80229 19.2186 8.79887 18.6576 8.79887 18.4425C8.79887 18.2659 8.797 17.6699 8.797 17.6699H9.55928C9.98598 17.6699 10.347 18.0158 10.347 18.4425Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9271 17.6816H16.7841V20.3944H17.9271",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8428 19.0391H16.8309",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7888 17.6816H2.64575V20.3944H3.7888",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70464 19.0391H2.69275",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30636 22.1975H1.57838C0.900844 22.1975 0.351562 21.6482 0.351562 20.9707V8.04688H8.40337",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.021 8.04688H23.6485V20.9707C23.6485 21.6482 23.0992 22.1975 22.4217 22.1975H5.71265",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7803 8.04688H18.6147",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96124 3.72852H5.23474",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3179 3.72852H9.14709",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4633 3.72852H16.7848",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6484 8.51609V5.21516C23.6484 4.3941 22.9829 3.72852 22.1618 3.72852H20.9131",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87831 3.72852H1.8382C1.01714 3.72852 0.351562 4.3941 0.351562 5.21516V8.51609",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12099 5.57609C7.55427 5.57609 7.09485 5.11667 7.09485 4.54995V2.82692C7.09485 2.2602 7.55427 1.80078 8.12099 1.80078C8.68771 1.80078 9.14713 2.2602 9.14713 2.82692V4.54995C9.14713 5.11667 8.68771 5.57609 8.12099 5.57609Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7849 11.2009C16.7849 13.8435 14.6426 15.9857 12 15.9857C9.35744 15.9857 7.21521 13.8435 7.21521 11.2009C7.21521 8.55825 9.35744 6.41602 12 6.41602C14.6426 6.41602 16.7849 8.55825 16.7849 11.2009Z",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9238 8.41602V11.2886L13.2719 12.6367",
    stroke: "#4F4F4D",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredInactive);
export default __webpack_public_path__ + "static/media/expired-inactive.0cdb25c1537743f868eda82f3ef9ff64.svg";
export { ForwardRef as ReactComponent };